import _extends from "@babel/runtime/helpers/extends";
import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";
import _toConsumableArray from "@babel/runtime/helpers/toConsumableArray";
import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _assertThisInitialized from "@babel/runtime/helpers/assertThisInitialized";
import _inherits from "@babel/runtime/helpers/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _defineProperty from "@babel/runtime/helpers/defineProperty";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import _regeneratorRuntime from "@babel/runtime/regenerator";

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

import React, { Component } from "react";
import { translate } from '@haldor/ui';
import { connect } from "react-redux";
import Moment from 'moment';
import { addError } from 'actions';
import { createBulkAssignments } from 'actions/assignments';
import { getPlansBySectionId, getPlanDetails, setActivePlan } from 'actions/plans';
import { getBlocksByReference, updateBlocksOnReference, createAssessmentBlock } from 'actions/blocks';
import { getScheduleForUser } from 'actions/schedule';
import { toggleSelectedSection, clearSelectedSections } from "actions/sections";
import { Form, Field } from 'react-final-form';
import { Expandable, List, Spinner } from 'UI';
import { Editor, TimePicker } from 'UI/Inputs';
import { Checkbox, Button } from '@haldor/ui';
import Upload from 'components/Inputs/upload';
import DatePickerFromTo from '../Partials/DatePickerFromTo';
import CustomSelector from '../Partials/CustomSelector';
import AttachedDocuments from 'components/Presentation/Documents/AttachedDocuments';
import InvalidGroupNotice from '../Partials/InvalidGroupNotice';
import BlockAssessments from 'components/BlockAssessments';
import { ASSESSMENT_TYPES } from "components/BlockAssessments/AssessmentTypes";
import MultipleSectionSelector from '../Partials/MultipleSectionSelector';
import TeacherAdjustments from 'containers/AdditionalAdjustments/Display/TeacherAdjustments';
import Modal from 'containers/Modals/Modal';
import DatePicker from 'react-datepicker';

var MultipleAssignmentForm = /*#__PURE__*/function (_Component) {
  _inherits(MultipleAssignmentForm, _Component);

  var _super = _createSuper(MultipleAssignmentForm);

  /* Class setup */
  function MultipleAssignmentForm(props) {
    var _props$initialValues, _props$initialValues2;

    var _this;

    _classCallCheck(this, MultipleAssignmentForm);

    _this = _super.call(this, props);

    _defineProperty(_assertThisInitialized(_this), "required", function (value) {
      if (typeof value !== 'undefined' && value !== '') {
        if (value.length > 199) {
          // Field failed validation, return error for this field (String)
          return _this.props.translate('field-max-200-chars');
        } // Field passes validation, return a undefined error for this field
        // Rule: Not undefined and not an empty string and not over 200 characters


        return undefined;
      } // Field failed validation, return error for this field (String)


      return _this.props.translate('field-needs-input');
    });

    _defineProperty(_assertThisInitialized(_this), "fixDescription", function (html) {
      html = html.replace(/&lt;/g, '<');
      html = html.replace(/&gt;/g, '>');
      html = html.replace(/\<\/b\>/gi, ' </b>');
      html = html.replace(/\<\/i\>/gi, ' </i>');
      html = html.replace(/\<\/a\>/gi, ' </a>');
      html = html.replace(/\<\/p\>/gi, ' </p>');
      return html;
    });

    _defineProperty(_assertThisInitialized(_this), "submit", function (values) {
      var _this$state = _this.state,
          dateStart = _this$state.dateStart,
          dateEnd = _this$state.dateEnd,
          tasks = _this$state.tasks,
          groupEnabled = _this$state.groupEnabled,
          status = _this$state.status,
          published = _this$state.published;
      return new Promise(function (resolve) {
        var isEditing = _this.props.editView;
        var assessmentBlocks = [];
        var assessmentType = 'TEACHER';

        if (_this.state.selectedLesson.length > 0) {
          var relation = [];

          _this.state.selectedLesson.map(function (items) {
            var obj = {
              CalendarEventId: items.id,
              ReferenceType: 'ASSIGNMENT',
              ReferenceId: 0
            };
            relation.push(obj);
          });

          values.relationships = relation;
        } else {
          values.relationships = [];
        }

        if (values.assessmentBlocks != null) {
          assessmentBlocks = _toConsumableArray(values.assessmentBlocks);
        }

        values.startDate = dateStart;
        values.dueDate = dateEnd;
        values.groupEnabled = groupEnabled;
        values.attachedFiles = _this.state.attachedFiles;
        values.planId = _this.state.planId;

        if (values.status === 'ASSIGNMENT_DRAFT') {
          values.published = null;
        } else {
          values.published = published;
        }

        values.status = status;

        if (_this.state.selfAssessment) {
          assessmentType = 'SELF';
        }

        if (_this.state.studentAssessment) {
          assessmentType = 'BUDDY';
        }

        values.assessmentType = assessmentType;

        if (_this.state.newDocuments.length > 0) {
          values.attachedFiles = [].concat(_toConsumableArray(values.attachedFiles), _toConsumableArray(_this.state.newDocuments));
        }

        if (_this.props.cloneView) {
          values.documentTemplates = null;
          values.assignmentDocuments = null;
          values.plans = null;
        }

        values.sections = JSON.parse(JSON.stringify(_this.state.sections));

        if (values.sections != null) {
          values.sections.forEach(function (section) {
            section.students = section.students != null ? section.students.filter(function (t) {
              return t.checked;
            }) : [];
            return section;
          });
        }

        delete values.assessmentBlocks;

        var that = _assertThisInitialized(_this);

        _this.props.createBulkAssignments(values).then( /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2() {
          var starttime, promises;
          return _regeneratorRuntime.wrap(function _callee2$(_context2) {
            while (1) {
              switch (_context2.prev = _context2.next) {
                case 0:
                  if (_this.props.onSubmit) {
                    starttime = Moment(values.dueDate).utc().format();

                    _this.props.onSubmit(starttime);
                  }

                  if (!(values.planId != null && values.planId != 0)) {
                    _context2.next = 4;
                    break;
                  }

                  _context2.next = 4;
                  return new Promise( /*#__PURE__*/function () {
                    var _ref2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(resolve) {
                      var blocks;
                      return _regeneratorRuntime.wrap(function _callee$(_context) {
                        while (1) {
                          switch (_context.prev = _context.next) {
                            case 0:
                              _context.next = 2;
                              return _this.props.getBlocksByReference(values.planId, 'PLAN');

                            case 2:
                              blocks = [];

                              if (_this.props.planBlocks != null && _this.props.planBlocks.length > 0) {
                                blocks = _toConsumableArray(_this.props.planBlocks);
                                blocks.forEach(function (block) {
                                  if (block.type == 'Haldor.Blocks.Assignment') {
                                    if (block.resources != null) {
                                      var _block$resources$filt;

                                      var resources = [];
                                      var typeResource = (_block$resources$filt = block.resources.filter(function (resource) {
                                        return resource['@odata.type'] == 'assessmenttype';
                                      })[0]) === null || _block$resources$filt === void 0 ? void 0 : _block$resources$filt.value;
                                      block.resources.forEach(function (resource) {
                                        if (resource['@odata.type'] != 'assessmenttype') {
                                          resources.push({
                                            assessmentType: typeResource == null ? ASSESSMENT_TYPES.TEACHER : typeResource,
                                            id: resource.id,
                                            '@odata.type': resource['@odata.type']
                                          });
                                        }
                                      });
                                      block.resources = resources;
                                    }
                                  }

                                  block['_Resources'] = null;
                                  return block;
                                });
                              }

                              blocks.push({
                                type: 'Haldor.Blocks.Assignment',
                                title: '',
                                value: '',
                                sortorder: blocks.length,
                                id: 0,
                                resources: [{
                                  '@odata.type': 'haldor.assignment.block.assignment',
                                  id: _this.props.createdAssignments[0].id
                                }]
                              });
                              _context.next = 7;
                              return _this.props.updateBlocksOnReference(blocks, values.planId, 'PLAN');

                            case 7:
                              resolve(1);

                            case 8:
                            case "end":
                              return _context.stop();
                          }
                        }
                      }, _callee);
                    }));

                    return function (_x) {
                      return _ref2.apply(this, arguments);
                    };
                  }());

                case 4:
                  promises = [];
                  assessmentBlocks.forEach(function (block) {
                    if (_this.props.cloneView) {
                      block.resources.map(function (resource) {
                        resource.originId = resource.id;
                        resource.id = 0;
                        return resource;
                      });
                    }

                    _this.props.createdAssignments.forEach(function (assignment) {
                      promises.push(new Promise(function (resolve) {
                        _this.props.createAssessmentBlock(block, assignment.id, 'ASSIGNMENT').then(function () {
                          resolve(1);
                        });
                      }));
                    });
                  });
                  Promise.all(promises).then(function () {
                    that.props.onAbort(true);
                    resolve(true);
                  });

                case 7:
                case "end":
                  return _context2.stop();
              }
            }
          }, _callee2);
        })));
      });
    });

    _defineProperty(_assertThisInitialized(_this), "componentWillUnmount", function () {
      _this.props.clearSelectedSections();
    });

    _defineProperty(_assertThisInitialized(_this), "componentDidMount", function () {
      if (_this.props.section != null) {
        _this.props.toggleSelectedSection(_this.props.section);

        _this.props.getPlansBySectionId(_this.props.section.id);
      }

      if (_this.props.planid != null) {
        _this.setState({
          loadingPlan: true
        });

        _this.props.getPlanDetails(_this.props.planid).then(function () {
          _this.setState({
            associatedMatrices: _this.props.plan.associatedMatrices,
            loadingPlan: false
          });
        });
      }

      var attachedFiles = _this.state.attachedFiles;

      if (_this.props.initialValues != null && _this.props.initialValues.assignmentDocuments != null) {
        var files = _this.props.initialValues.assignmentDocuments.split(';');

        files.forEach(function (file) {
          if (file != '') {
            var fileObj = {
              key: file.substring(file.lastIndexOf('/') + 1),
              value: file,
              fileType: 1
            };
            attachedFiles.push(fileObj);
          }
        });
      }

      if (_this.props.initialValues != null && _this.props.initialValues.documentTemplates != null) {
        var files = _this.props.initialValues.documentTemplates.split(';');

        files.forEach(function (file) {
          if (file != '') {
            var fileObj = {
              key: file.substring(file.lastIndexOf('/') + 1),
              value: file,
              fileType: 2
            };
            attachedFiles.push(fileObj);
          }
        });
      }

      if (attachedFiles.length > 0) {
        _this.setState({
          attachedFiles: attachedFiles
        });
      }
    });

    _defineProperty(_assertThisInitialized(_this), "onStudentAssessmentChange", function (checked) {
      _this.setState({
        studentAssessment: checked
      });
    });

    _defineProperty(_assertThisInitialized(_this), "handleLessons", function (checked, lessonObj) {
      _this.setState(function (prevState) {
        return {
          selectedLesson: checked ? [].concat(_toConsumableArray(prevState.selectedLesson), [lessonObj]) : prevState.selectedLesson.filter(function (x) {
            return x.id != lessonObj.id;
          }),
          toggleLesson: checked ? _objectSpread(_objectSpread({}, prevState.toggleLesson), {}, _defineProperty({}, lessonObj.id, true)) : _objectSpread(_objectSpread({}, prevState.toggleLesson), {}, _defineProperty({}, lessonObj.id, false))
        };
      });
    });

    _defineProperty(_assertThisInitialized(_this), "handleStatus", function (value) {
      _this.setState({
        status: value
      });
    });

    _defineProperty(_assertThisInitialized(_this), "formatDate", function (date, length, lessonDate) {
      if (length) {
        Moment.utc(date).set({
          second: 0,
          millisecond: 0
        }).local().add(length, 'minutes').format('HH:mm');
      }
    });

    _defineProperty(_assertThisInitialized(_this), "onDateChange", function (dates) {
      _this.setState({
        dateStart: dates.start,
        dateEnd: dates.end,
        allowFetch: true
      });
    });

    _defineProperty(_assertThisInitialized(_this), "onUserListGroupToggle", function (checked) {
      _this.setState({
        groupEnabled: checked
      });
    });

    _defineProperty(_assertThisInitialized(_this), "onLessonChange", function (value) {
      _this.setState({
        selectedLesson: value
      });
    });

    _defineProperty(_assertThisInitialized(_this), "filterLesson", function (data) {
      var sortByStartTime = function sortByStartTime(a, b) {
        return Moment(a.startTime).diff(b.startTime);
      };

      if (_this.state.selectedLesson.length > 0) {
        var filter = data.filter(function (item) {
          return !_this.state.selectedLesson.find(function (f) {
            return f.id === item.id;
          });
        });
        return filter.concat(_this.state.selectedLesson).sort(sortByStartTime);
      }

      return data.sort(sortByStartTime);
    });

    _defineProperty(_assertThisInitialized(_this), "fetchLesson", function () {
      if (!_this.state.allowFetch) {
        return;
      } //dont fetch if both start and end date is same


      var start = _this.state.dateStart;
      var end = _this.state.dateEnd;
      var diff = end.diff(start, 'minutes');

      if (diff === 0) {
        return;
      }

      _this.setState({
        isFetchingLesson: true
      });

      if (_this.state.dateStart && _this.state.dateEnd) {
        _this.props.getScheduleForUser(_this.props.user.id, Moment(_this.state.dateStart).utc().set({
          second: 0,
          millisecond: 0
        }).toISOString(), Moment(_this.state.dateEnd).utc().set({
          second: 0,
          millisecond: 0
        }).toISOString()).then(function () {
          _this.setState({
            lesson: _this.filterLesson(_this.props.usersSchedule[_this.props.user.id]),
            isFetchingLesson: false,
            allowFetch: false
          });
        })["catch"](function (e) {
          console.log(e);

          _this.setState({
            isFetchingLesson: true
          });
        });
      } else {
        var startTime = Moment().utc().set({
          hour: 0,
          minute: 0,
          second: 0
        }).toISOString();
        var endTime = Moment().utc().set({
          hour: 23,
          minute: 59,
          second: 59
        }).toISOString();

        _this.props.getScheduleForUser(_this.props.user.id, startTime, endTime).then(function () {
          _this.setState({
            lesson: _this.filterLesson(_this.props.usersSchedule[_this.props.user.id]),
            isFetchingLesson: true,
            allowFetch: false
          });
        })["catch"](function (e) {
          _this.setState({
            isFetchingLesson: true
          });
        });
      }
    });

    _defineProperty(_assertThisInitialized(_this), "selectDocument", function (files) {
      _this.setState({
        newDocuments: files
      });
    });

    _defineProperty(_assertThisInitialized(_this), "removeInstruction", function (instruction, remove) {
      var attachedFiles = _this.state.attachedFiles;
      var removeFile = attachedFiles.find(function (file) {
        return file.value == instruction;
      });

      if (removeFile != null) {
        if (_this.props.cloneView) {
          attachedFiles = attachedFiles.filter(function (t) {
            return t.value != instruction;
          });
        } else {
          if (removeFile.markedForDeletion == true && remove == false) {
            var removeFileIndex = attachedFiles.findIndex(function (file) {
              return file.value == instruction;
            });
            attachedFiles.splice(removeFileIndex, 1);
          }
        }
      } else {
        if (remove) {
          var assignmentDocuments = _this.props.initialValues ? _this.props.initialValues.assignmentDocuments != null ? _this.props.initialValues.assignmentDocuments.split(';') : [] : [];
          var files = [];
          assignmentDocuments.forEach(function (document) {
            if (document == instruction && document != '' && document != null) {
              var _removeFile = {
                markedForDeletion: remove,
                fileType: 1,
                value: document,
                key: ''
              };
              attachedFiles.push(_removeFile);
            }
          });
        } else {
          var file = {
            fileType: 1,
            value: instruction,
            key: instruction.substring(instruction.lastIndexOf('/') + 1)
          };
          attachedFiles.push(file);
        }
      }

      _this.setState({
        attachedFiles: attachedFiles
      });
    });

    _defineProperty(_assertThisInitialized(_this), "setStudentAssessment", function (checked) {
      if (checked) {
        _this.setState({
          studentAssessment: checked,
          selfAssessment: !checked
        });
      } else {
        _this.setState({
          studentAssessment: checked
        });
      }
    });

    _defineProperty(_assertThisInitialized(_this), "handleDisplayDate", function (date) {
      _this.setState({
        tempPublishDate: Moment(date)
      });
    });

    _defineProperty(_assertThisInitialized(_this), "onSubmitDisplayDate", function () {
      _this.setState({
        published: _this.state.tempPublishDate,
        createEvent: false
      });
    });

    _defineProperty(_assertThisInitialized(_this), "handleDisplayInSchedule", function (event) {
      event.preventDefault();

      _this.setState({
        createEvent: true
      });
    });

    _defineProperty(_assertThisInitialized(_this), "closeModal", function () {
      var _this$state$published;

      _this.setState({
        tempPublishDate: (_this$state$published = _this.state.published) !== null && _this$state$published !== void 0 ? _this$state$published : Moment().local(),
        createEvent: false
      });
    });

    _defineProperty(_assertThisInitialized(_this), "setSelfAssessment", function (checked) {
      if (checked) {
        _this.setState({
          studentAssessment: !checked,
          selfAssessment: checked
        });
      } else {
        _this.setState({
          selfAssessment: checked
        });
      }
    });

    _defineProperty(_assertThisInitialized(_this), "onSectionsChange", function (groups) {
      var _assertThisInitialize, _assertThisInitialize2;

      _this.setState({
        sections: groups
      });

      if (groups.length == 1) {
        _this.props.getPlansBySectionId(groups[0].id);
      }

      if ((_assertThisInitialize = _assertThisInitialized(_this)) !== null && _assertThisInitialize !== void 0 && (_assertThisInitialize2 = _assertThisInitialize.props) !== null && _assertThisInitialize2 !== void 0 && _assertThisInitialize2.displayTitle && groups !== null && groups !== void 0 && groups.length) {
        var _assertThisInitialize3, _assertThisInitialize4;

        var title = '';
        groups.forEach(function (element) {
          if ((element === null || element === void 0 ? void 0 : element.students.length) > 0) {
            title = element === null || element === void 0 ? void 0 : element.title;
          }
        });
        (_assertThisInitialize3 = _assertThisInitialized(_this)) === null || _assertThisInitialize3 === void 0 ? void 0 : (_assertThisInitialize4 = _assertThisInitialize3.props) === null || _assertThisInitialize4 === void 0 ? void 0 : _assertThisInitialize4.displayTitle(title);
      }
    });

    _defineProperty(_assertThisInitialized(_this), "toggleAllStudents", function (checked) {
      var sections = _this.state.sections;
      sections.forEach(function (section) {
        section.students.forEach(function (student) {
          student.checked = checked;
          return student;
        });
        return section;
      });

      _this.setState({
        sections: sections
      });
    });

    _defineProperty(_assertThisInitialized(_this), "onAddSectionCourse", function (newGroups) {
      var sections = _this.state.sections;
      sections.forEach(function (section) {
        var newData = newGroups.find(function (group) {
          return group.id == section.id;
        });

        if (newData != null) {
          section.courses = newData.courses;
        }

        return section;
      });

      _this.setState({
        sections: sections
      });
    });

    _defineProperty(_assertThisInitialized(_this), "onPlanChange", function (event, form) {
      if (event.target.value != '0') {
        _this.setState({
          loadingPlan: true,
          planId: event.target.value
        });

        _this.props.getPlanDetails(event.target.value).then( /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee3() {
          var _form$getFieldState, assessmentBlocks, values;

          return _regeneratorRuntime.wrap(function _callee3$(_context3) {
            while (1) {
              switch (_context3.prev = _context3.next) {
                case 0:
                  _context3.next = 2;
                  return _this.props.getBlocksByReference(event.target.value, 'PLAN');

                case 2:
                  if (_this.props.planBlocks != null) {
                    assessmentBlocks = _this.props.planBlocks.filter(function (block) {
                      return block.type == 'Haldor.Blocks.AssessmentBlock';
                    }).map(function (block) {
                      return _objectSpread(_objectSpread({}, block), {}, {
                        id: 0,
                        referenceId: 0,
                        referenceType: ''
                      });
                    });
                    values = (_form$getFieldState = form.getFieldState('assessmentBlocks')) === null || _form$getFieldState === void 0 ? void 0 : _form$getFieldState.value;

                    if (values == null) {
                      values = _toConsumableArray(assessmentBlocks);
                    } else {
                      values = [].concat(_toConsumableArray(values), _toConsumableArray(assessmentBlocks));
                    }

                    form.change('assessmentBlocks', values);
                  }

                  _this.setState({
                    loadingPlan: false
                  });

                case 4:
                case "end":
                  return _context3.stop();
              }
            }
          }, _callee3);
        })));
      } else {
        _this.props.setActivePlan(null);

        _this.setState({
          loadingPlan: true,
          planId: 0
        }, function () {
          _this.setState({
            loadingPlan: false
          });
        });
      }
    });

    _defineProperty(_assertThisInitialized(_this), "renderInput", function (_ref4) {
      var input = _ref4.input,
          label = _ref4.label,
          type = _ref4.type,
          placeholder = _ref4.placeholder,
          _ref4$meta = _ref4.meta,
          touched = _ref4$meta.touched,
          error = _ref4$meta.error,
          warning = _ref4$meta.warning;
      return /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("input", _extends({
        placeholder: placeholder || label,
        type: type,
        style: touched && error ? {
          border: '1px solid red'
        } : {}
      }, input)), touched && (error && /*#__PURE__*/React.createElement("span", {
        style: {
          marginTop: '1rem',
          color: 'red'
        }
      }, error) || warning && /*#__PURE__*/React.createElement("span", {
        style: {
          marginTop: '1rem',
          color: 'red'
        }
      }, warning)));
    });

    _this.sectionsLocked = false;
    var _sections = [];

    if (props.section != null) {
      _this.sectionsLocked = true;
      _sections = [props.section];

      _sections.forEach(function (section) {
        section.students.forEach(function (student) {
          student.checked = true;
          return student;
        });
        return section;
      });
    }

    var _dateStart = Moment().second(0);

    var dueDate = null;

    if (props.date != null) {
      _dateStart = props.date;
    }

    if (((_props$initialValues = props.initialValues) === null || _props$initialValues === void 0 ? void 0 : _props$initialValues.startDate) != null) {
      _dateStart = props.initialValues.startDate;
    }

    if ((_props$initialValues2 = props.initialValues) !== null && _props$initialValues2 !== void 0 && _props$initialValues2.dueDate) {
      var _props$initialValues3;

      dueDate = (_props$initialValues3 = props.initialValues) === null || _props$initialValues3 === void 0 ? void 0 : _props$initialValues3.dueDate;
    }

    _this.state = {
      dateStart: props.hasDate ? Moment(props.hasDate) : _dateStart,
      dateEnd: dueDate,
      tasks: null,
      createEvent: false,
      studentAssessment: false,
      selfAssessment: false,
      groupEnabled: false,
      published: Moment().local(),
      tempPublishDate: Moment().local(),
      status: 'ASSIGNMENT_OPEN',
      allowFetch: true,
      lesson: [],
      attachedFiles: [],
      newDocuments: [],
      sections: _sections,
      loading: false,
      updated: false,
      loadingPlan: false,
      isFetchingLesson: false,
      selectedLesson: [],
      toggleLesson: {},
      planId: props.planid != null ? props.planid : 0,
      fileTypes: [{
        value: 1,
        text: _this.props.translate('instructions')
      }, {
        value: 2,
        text: _this.props.translate('template-document')
      }]
    };
    return _this;
  }
  /* Redux form functions */


  _createClass(MultipleAssignmentForm, [{
    key: "isIframe",
    value:
    /* Component methods and events */
    function isIframe() {
      try {
        return window.self !== window.top;
      } catch (e) {
        return true;
      }
    }
  }, {
    key: "render",
    value:
    /* Render form */
    function render() {
      var _this$props$initialVa,
          _this2 = this,
          _this$state2,
          _this$state2$sections;

      var initialValues = this.props.initialValues;

      if (this.state.loading) {
        return /*#__PURE__*/React.createElement(Spinner, {
          center: true
        });
      }

      var invalidDocuments = _toConsumableArray(this.state.newDocuments).filter(function (file) {
        if (file.fileType != null) {
          return file.fileType == 0;
        }

        return false;
      });

      var documentsPassing = true;

      if (invalidDocuments.length > 0) {
        documentsPassing = false;
      }

      var groups = [];
      var students = [];

      if (this.state.sections.length > 0) {
        this.state.sections.forEach(function (section) {
          if (section.students != null) {
            section.students.forEach(function (student) {
              return students.push(student.id);
            });
          }

          groups.push(section.id);
        });
      }

      if (this.state.dateStart != null) {
        initialValues.startDate = this.state.dateStart;
      }

      if (this.state.dateEnd != null) {
        initialValues.dueDate = this.state.dateEnd;
      }

      var subjects = [];
      return /*#__PURE__*/React.createElement("div", {
        className: "form-container form-create_task"
      }, /*#__PURE__*/React.createElement(InvalidGroupNotice, null), !this.sectionsLocked ? /*#__PURE__*/React.createElement(Expandable, {
        contentStyles: {
          padding: '1em 0rem'
        },
        contentStylesClosed: {
          padding: '0'
        },
        headerStyles: this.state.error != null ? {
          border: '1px solid red'
        } : {},
        whiteBackground: true,
        title: this.props.translate('choose-groups'),
        open: true,
        ignorePropsUpdate: true
      }, /*#__PURE__*/React.createElement(List, {
        style: {
          border: '0',
          margin: '0',
          boxShadow: '0'
        }
      }, /*#__PURE__*/React.createElement(MultipleSectionSelector, {
        value: (_this$props$initialVa = this.props.initialValues) === null || _this$props$initialVa === void 0 ? void 0 : _this$props$initialVa.sectionId,
        onChange: this.onSectionsChange,
        type: "assignment"
      }))) : /*#__PURE__*/React.createElement(Expandable, {
        contentStyles: {
          padding: '1em 0rem'
        },
        contentStylesClosed: {
          padding: '0'
        },
        headerStyles: this.state.error != null ? {
          border: '1px solid red'
        } : {},
        whiteBackground: true,
        title: /*#__PURE__*/React.createElement("div", {
          style: {
            display: 'inline-block'
          },
          onClick: function onClick(e) {
            e.stopPropagation();
            e.preventDefault();
          }
        }, /*#__PURE__*/React.createElement(Checkbox, {
          value: true,
          onChange: function onChange(c) {
            return _this2.toggleAllStudents(c);
          },
          label: ((_this$state2 = this.state) === null || _this$state2 === void 0 ? void 0 : (_this$state2$sections = _this$state2.sections) === null || _this$state2$sections === void 0 ? void 0 : _this$state2$sections.length) > 0 ? this.state.sections[0].title : this.props.translate('select-students'),
          disabled: this.props.disabled
        })),
        open: true,
        ignorePropsUpdate: true
      }, this.state.sections.map(function (section) {
        return /*#__PURE__*/React.createElement("div", {
          style: {
            padding: '0 2.5em'
          },
          key: section.id
        }, section.students.sort(function (a, b) {
          return a.lastName.localeCompare(b.lastName);
        }).map(function (student) {
          return /*#__PURE__*/React.createElement("div", {
            key: student.id,
            style: {
              marginBottom: '.4rem'
            }
          }, /*#__PURE__*/React.createElement(Checkbox, {
            value: student.checked,
            label: student.firstName + ' ' + student.lastName,
            onChange: function onChange(value) {
              student.checked = value;
            }
          }));
        }));
      })), /*#__PURE__*/React.createElement(Form, {
        onSubmit: this.submit,
        initialValues: this.props.initialValues,
        initialValuesEqual: function initialValuesEqual() {
          return true;
        },
        mutators: {
          setStatusDraft: function setStatusDraft(args, state, utils) {
            utils.changeValue(state, 'status', function () {
              return 'ASSIGNMENT_DRAFT';
            });
          }
        },
        render: function render(_ref5) {
          var _form$getFieldState2, _this2$props$lesson, _this2$props$lesson2, _this2$props$lesson3, _this2$props$lesson4, _this2$props$lesson5, _this2$props, _this2$props2, _this2$props3, _this2$state$selected, _this2$state$selected2;

          var submitting = _ref5.submitting,
              handleSubmit = _ref5.handleSubmit,
              form = _ref5.form,
              valid = _ref5.valid;
          var assessmentBlocks = (_form$getFieldState2 = form.getFieldState('assessmentBlocks')) === null || _form$getFieldState2 === void 0 ? void 0 : _form$getFieldState2.value;
          var subjects = [];

          if ((assessmentBlocks === null || assessmentBlocks === void 0 ? void 0 : assessmentBlocks.length) > 0) {
            assessmentBlocks === null || assessmentBlocks === void 0 ? void 0 : assessmentBlocks.forEach(function (content) {
              var _content$resources;

              content === null || content === void 0 ? void 0 : (_content$resources = content.resources) === null || _content$resources === void 0 ? void 0 : _content$resources.forEach(function (resources) {
                var _resources$value;

                if (resources !== null && resources !== void 0 && (_resources$value = resources.value) !== null && _resources$value !== void 0 && _resources$value.details) {
                  var _resources$value2;

                  if (subjects.indexOf((_resources$value2 = resources.value) === null || _resources$value2 === void 0 ? void 0 : _resources$value2.subjectId) == -1) {
                    var _resources$value3;

                    subjects.push(parseInt((_resources$value3 = resources.value) === null || _resources$value3 === void 0 ? void 0 : _resources$value3.subjectId));
                  }
                }
              });
            });
          }

          return /*#__PURE__*/React.createElement("form", {
            onSubmit: handleSubmit,
            className: "form form-component"
          }, submitting ? /*#__PURE__*/React.createElement("div", {
            className: "is_sending"
          }, /*#__PURE__*/React.createElement("p", null, /*#__PURE__*/React.createElement("span", {
            className: "loading-spinner"
          }))) : null, /*#__PURE__*/React.createElement("div", {
            className: "form-row select"
          }, /*#__PURE__*/React.createElement("label", null, _this2.props.translate('Status')), /*#__PURE__*/React.createElement("select", {
            onChange: function onChange(e) {
              return _this2.handleStatus(e.target.value);
            }
          }, _this2.props.assignmentStatus.filter(function (x) {
            return x.id !== 'ASSIGNMENT_DRAFT';
          }).map(function (item) {
            return /*#__PURE__*/React.createElement("option", {
              key: item.id,
              value: item.id
            }, item.id === 'ASSIGNMENT_CLOSED' ? _this2.props.translate('Hidden') : item.value);
          }))), /*#__PURE__*/React.createElement("div", {
            className: "form-row select"
          }, /*#__PURE__*/React.createElement("label", null, _this2.props.translate('type'), "*"), /*#__PURE__*/React.createElement(Field, {
            component: "select",
            name: "assignmentType",
            validate: _this2.required
          }, /*#__PURE__*/React.createElement("option", {
            value: ""
          }, _this2.props.translate('select-an-alternative')), _this2.props.assignmentTypes.map(function (item) {
            return /*#__PURE__*/React.createElement("option", {
              key: item.id,
              value: item.id
            }, item.value);
          }))), _this2.state.sections.length == 1 && !_this2.props.disablePlanSelector ? /*#__PURE__*/React.createElement("div", {
            className: "form-row select"
          }, /*#__PURE__*/React.createElement("label", null, _this2.props.translate('planning')), /*#__PURE__*/React.createElement("select", {
            disabled: _this2.props.planid != null,
            onChange: function onChange(e) {
              return _this2.onPlanChange(e, form);
            },
            value: _this2.state.planId
          }, /*#__PURE__*/React.createElement("option", {
            value: "0"
          }, _this2.props.translate('pick-a-plan')), _this2.props.sectionPlans.map(function (sectionPlan) {
            return /*#__PURE__*/React.createElement("option", {
              value: sectionPlan.id
            }, sectionPlan.title);
          }))) : null, /*#__PURE__*/React.createElement("div", {
            className: "form-row input"
          }, /*#__PURE__*/React.createElement("label", null, _this2.props.translate('title'), "*"), /*#__PURE__*/React.createElement(Field, {
            component: _this2.renderInput,
            type: "text",
            name: "title",
            placeholder: _this2.props.translate('title'),
            validate: _this2.required
          })), /*#__PURE__*/React.createElement("div", {
            className: "form-row input"
          }, /*#__PURE__*/React.createElement("label", null, _this2.props.translate('description')), /*#__PURE__*/React.createElement(Field, {
            component: Editor,
            name: "description",
            placeholder: _this2.props.translate('describe-assignment'),
            translate: _this2.props.translate
          })), /*#__PURE__*/React.createElement("div", {
            className: "form-row"
          }, /*#__PURE__*/React.createElement(DatePickerFromTo, {
            timePicker: true,
            type: "assignment",
            onChange: _this2.onDateChange,
            values: initialValues !== null && initialValues !== void 0 ? initialValues : {
              startDate: Moment(_this2.state.startDate)
            },
            cloneView: _this2.props.cloneView
          })), _this2.props.services.advancedSchedule ? /*#__PURE__*/React.createElement("div", {
            className: "form-row select"
          }, /*#__PURE__*/React.createElement("div", {
            className: "lesson-picker"
          }, /*#__PURE__*/React.createElement("label", null, _this2.props.translate('select lesson')), /*#__PURE__*/React.createElement(CustomSelector, {
            label: _this2.props.lesson ? /*#__PURE__*/React.createElement("div", {
              className: "selectorLabel"
            }, /*#__PURE__*/React.createElement("span", {
              className: "selectorItems"
            }, (_this2$props$lesson = _this2.props.lesson) !== null && _this2$props$lesson !== void 0 && _this2$props$lesson.startTime ? Moment((_this2$props$lesson2 = _this2.props.lesson) === null || _this2$props$lesson2 === void 0 ? void 0 : _this2$props$lesson2.startTime).format('dddd Do MMMM') : _this2.props.time.format('dddd Do MMMM'), ' ', (_this2$props$lesson3 = _this2.props.lesson) !== null && _this2$props$lesson3 !== void 0 && _this2$props$lesson3.startTime ? Moment.utc((_this2$props$lesson4 = _this2.props.lesson) === null || _this2$props$lesson4 === void 0 ? void 0 : _this2$props$lesson4.startTime).set({
              second: 0,
              millisecond: 0
            }).local().format('LT') : _this2.props.time.format('LT'), "-", ' ', (_this2$props$lesson5 = _this2.props.lesson) !== null && _this2$props$lesson5 !== void 0 && _this2$props$lesson5.startTime ? Moment.utc(_this2.props.lesson.startTime).set({
              second: 0,
              millisecond: 0
            }).local().add(_this2.props.lesson.length, 'minutes').format('LT') : Moment.utc((_this2$props = _this2.props) === null || _this2$props === void 0 ? void 0 : _this2$props.time).set({
              second: 0,
              millisecond: 0
            }).local().add((_this2$props2 = _this2.props) === null || _this2$props2 === void 0 ? void 0 : _this2$props2.end, 'minutes').format('LT')), /*#__PURE__*/React.createElement("span", {
              className: "selectorItems"
            }, (_this2$props3 = _this2.props) === null || _this2$props3 === void 0 ? void 0 : _this2$props3.lesson.title)) : ((_this2$state$selected = _this2.state.selectedLesson) === null || _this2$state$selected === void 0 ? void 0 : _this2$state$selected.length) > 1 ? /*#__PURE__*/React.createElement("span", null, (_this2$state$selected2 = _this2.state.selectedLesson) === null || _this2$state$selected2 === void 0 ? void 0 : _this2$state$selected2.length, ' ', _this2.props.translate('lessons-selected')) : _this2.state.selectedLesson.length === 1 ? /*#__PURE__*/React.createElement("div", {
              className: "selectorLabel"
            }, /*#__PURE__*/React.createElement("span", {
              className: "selectorItems"
            }, Moment.utc(_this2.state.selectedLesson[0].startTime).local().format('dddd Do MMMM'), ' ', Moment.utc(_this2.state.selectedLesson[0].startTime).set({
              second: 0,
              millisecond: 0
            }).local().format('LT'), ' ', "-", ' ', Moment.utc(_this2.state.selectedLesson[0].startTime).set({
              second: 0,
              millisecond: 0
            }).local().add(_this2.state.selectedLesson[0].length, 'minutes').format('LT')), /*#__PURE__*/React.createElement("span", {
              className: "selectorItems"
            }, _this2.state.selectedLesson[0].title)) : /*#__PURE__*/React.createElement("span", null, _this2.props.translate('select lesson')),
            lesson: _this2.props.lesson,
            fetchLesson: _this2.fetchLesson
          }, !_this2.state.isFetchingLesson ? _this2.state.lesson.length === 0 ? /*#__PURE__*/React.createElement("div", {
            className: "noLesson"
          }, /*#__PURE__*/React.createElement("span", null, _this2.props.translate('There are no lessons within the assignment time period'))) : _this2.state.lesson.map(function (lesson) {
            return /*#__PURE__*/React.createElement("div", {
              key: lesson.id,
              tabIndex: 0
            }, /*#__PURE__*/React.createElement(Checkbox, {
              value: _this2.state.toggleLesson[lesson.id],
              onChange: function onChange(checked) {
                return _this2.handleLessons(checked, lesson);
              },
              label: /*#__PURE__*/React.createElement("div", null, Moment(lesson.startTime).format('dddd Do MMMM'), ' ', Moment.utc(lesson.startTime).local().set({
                second: 0,
                millisecond: 0
              }).format('LT'), ' ', "-", ' ', Moment.utc(lesson.startTime).local().set({
                second: 0,
                millisecond: 0
              }).add(lesson.length, 'minutes').format('LT'), ' ', lesson.title)
            }));
          }) : /*#__PURE__*/React.createElement(Spinner, {
            center: true
          })))) : null, /*#__PURE__*/React.createElement("div", {
            style: {
              clear: 'both'
            }
          }), _this2.props.services.advancedSchedule ? /*#__PURE__*/React.createElement("div", {
            className: "form-row",
            style: {
              marginBottom: '1rem'
            }
          }, /*#__PURE__*/React.createElement("label", null, _this2.props.translate('publication date')), /*#__PURE__*/React.createElement(Button, {
            type: "dropDown",
            onClick: function onClick(e) {
              return _this2.handleDisplayInSchedule(e);
            }
          }, _this2.state.published.format('dddd Do MMMM'), ' ', _this2.state.published.format('LT'))) : null, /*#__PURE__*/React.createElement("div", {
            className: "form-divider"
          }), /*#__PURE__*/React.createElement(Expandable, {
            title: _this2.props.translate('Assessments')
          }, !_this2.state.loadingPlan ? /*#__PURE__*/React.createElement(Field, {
            component: BlockAssessments,
            name: "assessmentBlocks",
            multipleAssessmentOptions: true
          }) : null), (_this2.props.editView || _this2.props.cloneView) && _this2.props.initialValues.assignmentDocuments != null && _this2.props.initialValues.assignmentDocuments.length > 0 ? /*#__PURE__*/React.createElement("div", {
            className: "form-row",
            style: {
              marginBottom: '1em',
              width: '100%'
            }
          }, /*#__PURE__*/React.createElement("label", null, _this2.props.translate('instructions')), /*#__PURE__*/React.createElement(AttachedDocuments, {
            documents: _this2.props.initialValues.assignmentDocuments,
            removeInstruction: _this2.removeInstruction
          })) : null, _this2.props.cloneView && initialValues.documentTemplates != null && initialValues.documentTemplates.length > 0 ? /*#__PURE__*/React.createElement("div", {
            className: "form-row",
            style: {
              marginBottom: '1em',
              width: '100%'
            }
          }, /*#__PURE__*/React.createElement("label", null, _this2.props.translate('templates')), /*#__PURE__*/React.createElement(AttachedDocuments, {
            documents: initialValues.documentTemplates,
            removeInstruction: _this2.removeInstruction
          })) : null, /*#__PURE__*/React.createElement(Upload, {
            lockedStatus: _this2.state.status === 'ASSIGNMENT_LOCKED' ? true : false,
            onUpdate: _this2.selectDocument,
            attachedFiles: _this2.state.attachedFiles,
            form: "assignment"
          }), _this2.props.services.additionalAdjustments ? /*#__PURE__*/React.createElement(Expandable, {
            title: _this2.props.translate("additional-adjustments")
          }, /*#__PURE__*/React.createElement(TeacherAdjustments, {
            disableCommenting: true,
            subjects: subjects,
            groups: groups
          })) : null, /*#__PURE__*/React.createElement("div", {
            className: "form-divider"
          }), /*#__PURE__*/React.createElement("div", {
            className: "form-row spacing submit"
          }, /*#__PURE__*/React.createElement(Button, {
            onClick: function onClick(e) {
              e.preventDefault(); //form.mutators.setStatusOpen();

              form.submit();
            },
            disabled: submitting || !valid || !documentsPassing || _this2.state.sections.length == 0 || students.length == 0
          }, _this2.props.translate('publish')), /*#__PURE__*/React.createElement(Button, {
            onClick: function onClick(e) {
              e.preventDefault();
              form.mutators.setStatusDraft();
              form.submit();
            },
            type: "secondary",
            disabled: submitting || !valid || !documentsPassing || _this2.state.sections.length == 0 || students.length == 0
          }, _this2.props.translate('save-draft')), /*#__PURE__*/React.createElement("div", {
            className: "align-right"
          }, /*#__PURE__*/React.createElement(Button, {
            type: "secondary",
            onClick: function onClick(e) {
              e.preventDefault();

              _this2.props.onAbort(false);
            }
          }, _this2.props.translate('Cancel')))));
        }
      }), /*#__PURE__*/React.createElement(Modal, {
        isOpen: this.state.createEvent,
        onClose: this.closeModal,
        title: this.props.translate('add-date')
      }, /*#__PURE__*/React.createElement("div", {
        className: "in_scheduleFrom"
      }, /*#__PURE__*/React.createElement("div", {
        className: "timeStart_scheduleFrom"
      }, /*#__PURE__*/React.createElement("span", null, this.props.translate('start'), "*"), /*#__PURE__*/React.createElement(DatePicker, {
        selected: this.state.tempPublishDate,
        startDate: this.state.tempPublishDate,
        onChange: this.handleDisplayDate,
        popperPlacement: "bottom-end",
        positionFixed: true,
        popperModifiers: {
          preventOverflow: {
            enabled: true
          },
          positionFixed: false
        },
        selectsEnd: true,
        showWeekNumbers: true,
        fixedHeight: true,
        previousMonthButtonLabel: "",
        nextMonthButtonLabel: ""
      })), /*#__PURE__*/React.createElement("div", {
        className: "time_scheduleFrom"
      }, /*#__PURE__*/React.createElement("span", null, this.props.translate('start-time'), "*"), /*#__PURE__*/React.createElement(TimePicker, {
        placeholder: this.props.translate('pick-start-time'),
        time: this.state.tempPublishDate,
        onChange: this.handleDisplayDate
      })), /*#__PURE__*/React.createElement("div", {
        className: "submitTime"
      }, /*#__PURE__*/React.createElement(Button, {
        onClick: this.onSubmitDisplayDate
      }, this.props.translate('Save'))))));
    }
  }]);

  return MultipleAssignmentForm;
}(Component);

_defineProperty(MultipleAssignmentForm, "defaultProps", {
  cloneView: false,
  disablePlanSelector: false
});

function mapStateToProps(state, ownProps) {
  var _ownProps$planningAss, _state$planning$activ, _state$planning$activ2;

  var values = _objectSpread({}, ownProps.initialValues);

  if (values != null && ownProps.planid != null) {
    values.planId = ownProps.planid;
  } //handle current planningAssessments


  if ((ownProps === null || ownProps === void 0 ? void 0 : (_ownProps$planningAss = ownProps.planningAssessments) === null || _ownProps$planningAss === void 0 ? void 0 : _ownProps$planningAss.length) > 0) {
    var filteredAssessmentsBlocks = ownProps === null || ownProps === void 0 ? void 0 : ownProps.planningAssessments.filter(function (t) {
      return t.type === 'Haldor.Blocks.AssessmentBlock';
    });

    if (filteredAssessmentsBlocks.length > 0) {
      values.assessmentBlocks = filteredAssessmentsBlocks;
    }
  }

  if (values != null && state.Blocks.reference != null) {
    var blocks = JSON.parse(JSON.stringify(state.Blocks.reference));
    values.assessmentBlocks = blocks.filter(function (block) {
      return block.type == "Haldor.Blocks.AssessmentBlock";
    });
  } // handle previous planningAssessments


  if (((_state$planning$activ = state.planning.active_plan) === null || _state$planning$activ === void 0 ? void 0 : (_state$planning$activ2 = _state$planning$activ.blocks) === null || _state$planning$activ2 === void 0 ? void 0 : _state$planning$activ2.length) > 0 && ownProps.existingPlanningAssessments) {
    var _state$planning, _state$planning$activ3, _state$planning$activ4;

    values.assessmentBlocks = state === null || state === void 0 ? void 0 : (_state$planning = state.planning) === null || _state$planning === void 0 ? void 0 : (_state$planning$activ3 = _state$planning.active_plan) === null || _state$planning$activ3 === void 0 ? void 0 : (_state$planning$activ4 = _state$planning$activ3.blocks) === null || _state$planning$activ4 === void 0 ? void 0 : _state$planning$activ4.filter(function (t) {
      return t.type === 'Haldor.Blocks.AssessmentBlock';
    });
  }

  if (ownProps.lesson != null) {
    var lesson = JSON.parse(JSON.stringify(ownProps.lesson));
    values.startDate = Moment.utc(lesson.startTime).local();
    values.dueDate = Moment(values.startDate).add(ownProps.lesson.length, 'minutes');
  }

  if (ownProps.time != null) {
    values.startDate = Moment(ownProps.time);
  }

  if (ownProps.length != null && values.startDate != null) {
    values.dueDate = Moment(values.startDate).add(ownProps.length, 'minutes');
  }

  return {
    user: state.user.currentUser,
    sections: state.sections.educationGroups,
    assignmentTypes: state.status.status.assignmentTypes,
    assignmentStatus: state.status.status.assignmentStatus,
    translate: translate(state.Languages.translations),
    services: state.Services.availableServices,
    plan: state.planning.active_plan,
    sectionPlans: state.planning.sectionPlans,
    planBlocks: state.Blocks.reference,
    createdAssignments: state.assignments.newAssignments,
    initialValues: values,
    usersSchedule: state.schedule.usersSchedule
  };
}

export default connect(mapStateToProps, {
  createBulkAssignments: createBulkAssignments,
  addError: addError,
  getScheduleForUser: getScheduleForUser,
  getPlansBySectionId: getPlansBySectionId,
  getPlanDetails: getPlanDetails,
  setActivePlan: setActivePlan,
  getBlocksByReference: getBlocksByReference,
  updateBlocksOnReference: updateBlocksOnReference,
  createAssessmentBlock: createAssessmentBlock,
  toggleSelectedSection: toggleSelectedSection,
  clearSelectedSections: clearSelectedSections
})(MultipleAssignmentForm);